import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { isEmpty } from '@/utils'
import { userLoginInfo } from '@/apiUtils'

const service = axios.create({
	// timeout: 100000
})

service.interceptors.request.use(
	(config) => {
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

export const waitRequestQueue = []
service.interceptors.response.use(
	async (res) => {
		if (res.status === 200) {
			// 登录过期
			if (res.data.code === -1) {
				// if (!sessionStorage.getItem('loginSuccess')) {
				// 	if (!sessionStorage.getItem('Token')) {
				// 		const { Token } = await userLoginInfo()
				// 		sessionStorage.setItem('Token', Token)
				// 	}
				// 	router.push('/login')
				// 	return res.data
				// }
				if (!['/', '/login'].includes(router.currentRoute.path)) {
					// let resolve
					// const taskPromise = new Promise((_resolve) => {
					// 	resolve = _resolve
					// })
					// waitRequestQueue.push({
					// 	res: res,
					// 	resolve
					// })
					// store.commit('setTryLoginCallback', async (oldToken, newToken) => {
					// 	// 1. UI登录成功, 触发该回调
					// 	// 2. 执行队列任务, 将旧的Token替换为新的
					// 	waitRequestQueue.forEach(async (task) => {
					// 		const result = await service({
					// 			headers: task.res.config.headers,
					// 			method: task.res.config.method,
					// 			url: task.res.config.url.replace(oldToken, newToken),
					// 			data: task.res.config.headers['Content-Type'].includes('application/json')
					// 				? isEmpty(task.res.config.data)
					// 					? task.res.config.data
					// 					: JSON.parse(task.res.config.data)
					// 				: task.res.config.data
					// 		})
					// 		task.resolve(result)
					// 	})
					// 	waitRequestQueue.length = 0
					// 	store.commit('setShowTryLogin', false)
					// })
					// // 调出UI登录
					// store.commit('setShowTryLogin', true)
					// return taskPromise
					// router.push('/login')

					if (!sessionStorage.getItem('Token')) {
						const { Token } = await userLoginInfo()
						sessionStorage.setItem('Token', Token)
					}
					router.push('/login')
					return res.data

					// const info = await userLoginInfo()
					// if (info.Token === 'undefined' || info.Token === 'null') {
					// 	const { Token } = await userLoginInfo({}, false)
					// 	info.Token = Token
					// }
					// const OAuth2_jumpUrl = info.OAuth2_jumpUrl
					// sessionStorage.setItem('Token', info.Token)
					// sessionStorage.setItem('staffId', info.id)

					// // 子窗口监听放置于 main.js 中
					// window.open(
					// 	OAuth2_jumpUrl,
					// 	'popupWindow',
					// 	'width=800,height=800,top=200,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no'
					// )

					// return res.data
				}
			}
			sessionStorage.setItem('loginSuccess', '1')
			return res.data
		} else if (res.status >= 300) {
			const info = {
				code: 1,
				msg: `请求失败, 请重试 ! status: ${res.status}`,
				response: res,
				tip: '此信息来自请求拦截器, code 和 msg 为拦截器自定义, 不代表真实错误, 具体错误请查看开发者工具'
			}
			console.warn(info)
			return info
		}
		return res.data
	},
	(error) => {
		const info = {
			code: 1,
			msg: `未知错误, code: ${error.code}, message: ${error.message}, status: ${
				error?.response?.status ?? '无法获得'
			}`,
			error,
			tip: '此信息来自请求拦截器, code 和 msg 为拦截器自定义, 不代表真实错误, 具体错误请查看开发者工具'
		}
		if (error?.response?.status === 404) {
			info.msg = `资源不存在, status: 404`
		} else if (error?.response?.status === 403) {
			info.msg = `${error?.response?.data?.msg ?? '请勿使用敏感字符'}, status: 403`
		} else if (error?.response?.status >= 400 && error?.response?.status < 500) {
			info.msg = `${error?.response?.data?.msg ?? '客户端错误'}, status: ${
				error?.response?.status ?? '>= 400 && < 500'
			}`
		} else if (error?.response?.status >= 500) {
			info.msg = `${error?.response?.data?.msg ?? '服务器错误'}, status: ${error?.response?.status ?? '>= 500'}`
		} else if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
			info.msg = `网络或cors错误, code: ${error.code}, message: ${error.message}, status: ${
				error?.response?.status ?? '无法获得'
			}`
		}

		console.warn(info)
		return info
	}
)

export default service
